import { ECommerceApi } from '@itsrever/rever-api'
import { axiosInstance } from './api-configuration'

export const ecommerceApi = new ECommerceApi(
  undefined,
  undefined,
  axiosInstance
)
